<template>
  <div class="vl-user-setting">
    <ul class="menuUl">
      <p class="personSet">个人设置</p>
      <el-menu active-text-color="#4286F5" text-color="#333333" ref="sideNav">
        <el-menu-item
          @click="goPage(item)"
          :index="item.name"
          v-for="(item, index) in menuList"
          :key="index"
        >
          <span slot="title"> {{ item.title }}</span>
        </el-menu-item>
      </el-menu>
    </ul>
    <div class="tableCont readOnly">
      <router-view></router-view>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      menuList: [
        {
          title: "企业信息",
          name: "companyInfo",
        },
        {
          name: "safe",
          title: "安全与隐私",
        },
      ],
    };
  },
  mounted() {
    this.$_setTitle('个人设置-开放平台');
    this.$refs.sideNav.activeIndex = this.$route.name;
  },
  methods: {
    // 页面跳转
    goPage(item) {
      this.$router.push({ name: item.name });
    },
  },
};
</script>
<style lang="scss" scoped>
.vl-user-setting {
  display: flex;
  width: 1200px;
  margin: 0 auto;
  background: #ffffff;
  margin-top: 20px;
  min-height: 857px;
  .tableCont {
    width: calc(100% - 250px);
    padding: 40px 40px 50px;
    border: 1px solid #ebeef5;
    border-left: none;
  }
  .menuUl {
    width: 250px;
    border: 1px solid #ebeef5;
  }
  .menuUl .el-menu {
    border-right: none !important;
  }
  .menuUl .el-menu-item {
    font-size: 18px !important;
    height: 50px !important;
    line-height: 50px !important;
    padding-left: 50px !important;
    transition: background-color 0.3s, color 0.3s !important;
  }
  .menuUl .el-menu-item.is-active,
  .el-menu-item:hover {
    background-color: #f1f8ff !important;
  }
  .menuUl .el-menu-item.is-active {
    border-bottom: 1px solid #ebeef5;
    border-top: 1px solid #ebeef5;
    position: relative;
  }
  .menuUl .el-menu-item.is-active::after {
    content: "";
    position: absolute;
    width: 4px;
    height: 50px;
    background-color: #4286f5;
    left: 0;
    top: -1px;
  }
  .personSet {
    color: #333;
    font-size: 18px;
    font-weight: bold;
    padding: 20px 0 20px 50px;
    border-bottom: 1px solid #ebeef5;
  }
}
</style>